import Select from 'react-select'

export default function SubscriptionTopicsSelect({ onChange, value, isMulti = false, documentPortalTarget = true }) {
  const subscriptions = window.ENV.AVAILABLE_SUBSCRIPTIONS

  const buildOptions = (key) =>
    (subscriptions[key] || []).map(({ topic, label }) => ({ label, value: `${key}:${topic}` }))

  const options = [
    {
      label: "Email",
      options: buildOptions('email')
    },
    {
      label: "Phone",
      options: buildOptions('phone')
    },
    {
      label: "SMS",
      options: buildOptions('sms')
    },
    {
      label: "WhatsApp",
      options: buildOptions('whatsapp')
    },
  ]
  const flatOptions = options.map((option) => option.options).flat()

  const selectedValue = (() => {
    if (isMulti) {
      // Legacy data may not be migrated, so convert email_default to email:default etc.
      const valuesWithSemicolons = (value || []).map((v) => v.endsWith('_default') ? v.replace("_default", ":default") : v)
      const selectedOptions = flatOptions.filter((option) => {
        return valuesWithSemicolons.includes(option.value)
      })
      return selectedOptions
    } else {
      const selectedOption = flatOptions.find((option) => {
        if (!(value || '').includes(':')) {
          value = `${value}:default`
        }
        return option.value === value
      })
      return selectedOption
    }
  })()

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '200px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }

  return (
    <Select options={options}
      onChange={onChange}
      value={selectedValue}
      styles={customStyles}
      menuPortalTarget={documentPortalTarget ? document.body : null}
      isMulti={isMulti}
      classNamePrefix="subscription-topics-select" />
  )
}

